"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _accordionModule = _interopRequireDefault(require("./accordion.module.scss"));

var propTypes = {
  /** Text (or markup) to show as the title for this accordion */
  label: _propTypes["default"].node.isRequired,

  /** Contents of the accordion */
  children: _propTypes["default"].node.isRequired,

  /** Animate the toggling of the accordion if true */
  animated: _propTypes["default"].bool,

  /** Customise animation duration */
  animationDuration: _propTypes["default"].number
};
var defaultProps = {
  animated: false,
  animationDuration: 400
};

var Accordion = function Accordion(_ref) {
  var label = _ref.label,
      children = _ref.children,
      className = _ref.className,
      animated = _ref.animated,
      animationDuration = _ref.animationDuration,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["label", "children", "className", "animated", "animationDuration"]);
  var detailsRef = (0, _react.useRef)();
  var contentRef = (0, _react.useRef)();
  var summaryRef = (0, _react.useRef)();

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      animation = _useState2[0],
      setAnimation = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      isClosing = _useState4[0],
      setIsClosing = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      isExpanding = _useState6[0],
      setIsExpanding = _useState6[1];

  var _useState7 = (0, _react.useState)(animated),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      isAnimated = _useState8[0],
      setIsAnimated = _useState8[1];

  var animationOptions = {
    duration: animationDuration,
    easing: 'ease-out'
  };
  var handleAnimatedFinished = (0, _react.useCallback)(function (open) {
    var $detail = detailsRef.current;

    if ($detail) {
      $detail.open = open;
      setAnimation(null);
      setIsClosing(false);
      setIsExpanding(false);
      $detail.style.height = '';
      $detail.style.overflow = '';
    }
  }, []);
  var expand = (0, _react.useCallback)(function () {
    var $detail = detailsRef.current;
    var $content = contentRef.current;
    setIsExpanding(true);
    var startHeight = "".concat($detail.offsetHeight, "px");
    var endHeight = "".concat($detail.offsetHeight + $content.offsetHeight, "px");

    if (animation) {
      animation.cancel();
    }

    var runningAnimation = $detail.animate({
      height: [startHeight, endHeight]
    }, animationOptions);
    setAnimation(runningAnimation);

    runningAnimation.onfinish = function () {
      return handleAnimatedFinished(true);
    };

    runningAnimation.oncancel = function () {
      return setIsExpanding(false);
    };
  }, [animation, handleAnimatedFinished]);
  var shrink = (0, _react.useCallback)(function () {
    var $detail = detailsRef.current;
    var $summary = summaryRef.current;
    setIsClosing(true);
    var startHeight = "".concat($detail.offsetHeight, "px");
    var endHeight = "".concat($summary.offsetHeight, "px");

    if (animation) {
      animation.cancel();
    }

    var runningAnimation = $detail.animate({
      height: [startHeight, endHeight]
    }, animationOptions);
    setAnimation(runningAnimation);

    runningAnimation.onfinish = function () {
      return handleAnimatedFinished(false);
    };

    runningAnimation.oncancel = function () {
      return setIsClosing(false);
    };
  }, [animation, handleAnimatedFinished]);
  var open = (0, _react.useCallback)(function () {
    var $detail = detailsRef.current;
    $detail.style.height = "".concat($detail.offsetHeight, "px");
    $detail.open = true;
    window.requestAnimationFrame(function () {
      return expand();
    });
  }, [expand]);
  var handleClick = (0, _react.useCallback)(function (e) {
    var $detail = detailsRef.current;
    e.preventDefault();
    $detail.style.overflow = 'hidden';

    if (isClosing || !$detail.open) {
      open();
    } else if (isExpanding || $detail.open) {
      shrink();
    }
  }, [open, shrink, isClosing, isExpanding]);
  (0, _react.useEffect)(function () {
    var $detail = detailsRef.current;

    if ($detail) {
      setIsAnimated(isAnimated && 'animate' in $detail);
    }
  }, [isAnimated]);
  return /*#__PURE__*/_react["default"].createElement("details", (0, _extends2["default"])({
    ref: detailsRef,
    className: (0, _classnames["default"])(_accordionModule["default"]['c-accordion'], className)
  }, props), /*#__PURE__*/_react["default"].createElement("summary", {
    ref: summaryRef,
    onClick: isAnimated ? handleClick : undefined,
    role: "button",
    tabIndex: "0",
    className: _accordionModule["default"]['c-accordion__label']
  }, label), /*#__PURE__*/_react["default"].createElement("div", {
    className: _accordionModule["default"]['c-accordion__content'],
    ref: contentRef
  }, children));
};

Accordion.defaultProps = defaultProps;
Accordion.propTypes = propTypes;
var _default = Accordion;
exports["default"] = _default;